import { ExamDifficultyLevels, UsersTypeEnum } from "#/constants";
import { getExamQuestionsForResultSet } from "#/services/rest/gwt/exam-results/descriptive/exam-question-result-set";
import type { TExamQuestionsForResultSet } from "#/services/rest/gwt/exam-results/descriptive/exam-question-result-set.types";
import { auth } from "#/utils";
import { useParams } from "@monta/router-react";
import { useMemo } from "react";
import { origins } from "./constants";
import { QuestionTypes } from "./types";

export const useGetQuestions = (
  studentId: number,
  id?: number
): TExamQuestionsForResultSet[] => {
  const { examTakingId } = useParams();
  const user = auth.useAuth();

  const { data } = getExamQuestionsForResultSet.useQuery({
    request: {
      body: {
        examTakingId: examTakingId as string,
        studentId: user?.typeId !== UsersTypeEnum.STUDENT ? studentId : user.id
      }
    }
  });

  const questionMap = useMemo(() => {
    const map = new Map();
    data?.forEach((item) => map.set(item.id, item));
    return map;
  }, [data]);

  if (id) {
    const question = questionMap?.get(id) ?? {};
    return [question];
  }

  return data ?? [];
};

export const getDifficultyLevel = (difficultyLevelId: number) => {
  const result = {
    code: 3,
    label: "سخت"
  };

  if (
    difficultyLevelId === ExamDifficultyLevels["academic"] ||
    difficultyLevelId === ExamDifficultyLevels["easy"]
  ) {
    result.code = 1;
    result.label = "آسان";
  } else if (difficultyLevelId === ExamDifficultyLevels["normal"]) {
    result.code = 2;
    result.label = "متوسط";
  }

  return result;
};

export const getQuestionStatus = (params: Record<string, string>) => {
  const { selectedChoiceId, answerId } = params;
  return !selectedChoiceId ? "-1" : answerId === selectedChoiceId ? "1" : "0";
};

export const getOriginById = (id: number) => {
  const origin = origins.find((origin) => origin.id === id);

  if (origin) return origin;

  return null;
};

const getReadingQuestionNumberInExamEditor = (
  questionOrder1: number,
  numberOfChildren: number
): string => {
  const questionNo = `${questionOrder1 + 1} - ${
    questionOrder1 + numberOfChildren
  }`;

  return questionNo;
};

export const getQuestionIndex = (
  questionTypeId: QuestionTypes,
  numberOfChildren: number,
  questionOrder1: number
) => {
  if (
    questionTypeId === QuestionTypes.READING_MULTIPLECHOICE &&
    numberOfChildren !== 0
  ) {
    return getReadingQuestionNumberInExamEditor(
      questionOrder1,
      numberOfChildren
    );
  }

  return questionOrder1;
};
